const PATH = '/attachments'

export default Object.freeze({
    PATH,
})
